// src/components/Footer.jsx
import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="footer-container">

        {/* 1) SEDES PRIMERO */}
        <div className="locations">
          <div className="footer-social-row">
          <div className="brand-blurb">
            <h3>Conoce nuestras sedes</h3>
          </div>
          </div>
          
          <div className="locations-grid">
            {/* Matriz */}
            <div className="location-card">
              <h5>Matriz – Alpallana E7-248 & Diego de Almagro</h5>
              <p>Alpallana, Edificio Forum 300 E7-248 y Diego de Almagro</p>
              <p>Quito – Pichincha</p>
              <div style={{ marginBottom: "10px" }}></div>
              <p className="location-contact">
                <a href="tel:+593981031263">026 043191</a> · Ext: 101
              </p>
             <div style={{ marginBottom: "10px" }}></div>
              <p className="location-links">
                <a href="mailto:recepcion@roboticminds.com.ec">recepcion@roboticminds.com.ec</a> {''}
                <a href="https://www.google.com/maps?q=Alpallana+E7-248+%26+Diego+de+Almagro,+Quito" target="_blank" rel="noopener noreferrer">
                  Ver mapa
                </a>
              </p>
            </div>

            {/* Cumbayá */}
            <div className="location-card">
              <h5>Sede Cumbayá – IMPAQTO Coworking </h5>
              <p>Alba Calderón y Padre Luis Garzón / Impaqto Cumbayá</p>
              <p>Cumbayá – Pichincha</p>
              <div style={{ marginBottom: "10px" }}></div>
              <p className="location-contact">
                <a href="tel:+593981031263">593 026 043191 </a> · Ext: 600
              </p>
              <div style={{ marginBottom: "10px" }}></div>
              <p className="location-links">
                <a href="mailto:recepcion@roboticminds.com.ec">recepcion@roboticminds.com.ec</a> {' '}
                <a href="https://www.google.com/maps?q=Impaqto+Cumbay%C3%A1,+Quito" target="_blank" rel="noopener noreferrer">
                  Ver mapa
                </a>
              </p>
            </div>

            {/* Campus Luciano Astudillo */}
            <div className="location-card">
              <h5>Robotic Minds Ed Tech – Campus Luciano Astudillo</h5>
              <p>Valle de los Chillos – Pje. Sagitario S2-144 y, Quito 170804</p>
              <p>Quito – Pichincha</p>
              <div style={{ marginBottom: "10px" }}></div>
              <p className="location-contact">
                <a href="tel:+593981031263">593 026 043191</a> · Ext: 403
              </p>
              <div style={{ marginBottom: "10px" }}></div>
              <p className="location-links">
                <a href="mailto:recepcion@roboticminds.com.ec">recepcion@roboticminds.com.ec</a> {' '}
                <a href="https://www.google.com/maps?q=Pje.+Sagitario+S2-144,+Quito+170804" target="_blank" rel="noopener noreferrer">
                  Ver mapa
                </a>
              </p>
            </div>

            {/* Urdesa */}
            <div className="location-card">
              <h5>Sede Urdesa</h5>
              <p>Av. Circunvalación Sur 626, entre Ficus</p>
              <p>Guayaquil – Guayas</p>
              <div style={{ marginBottom: "10px" }}></div>
              <p className="location-contact">
                <a href="tel:+593981031263">593 026 043191</a> · Ext: 500
              </p>
              <div style={{ marginBottom: "10px" }}></div>
              <p className="location-links">
                <a href="mailto:recepciongye@roboticminds.com.ec">recepciongye@roboticminds.com.ec</a> {' '}
                <a href="https://www.google.com/maps?q=Av.+Circunvalaci%C3%B3n+Sur+626,+Guayaquil" target="_blank" rel="noopener noreferrer">
                  Ver mapa
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* 2) FRANJA REDES SOCIALES ABAJO */}
        <div className="footer-social-row">
          <div className="brand-blurb">
            <h4>ROBOTICMINDS</h4>
            <p>Visita nuestras redes sociales para conocer mas...</p>
          </div>

          <div className="social-links" role="list" aria-label="Redes sociales">
            {/* Facebook */}
            <a role="listitem" className="social-btn"
               href="https://www.facebook.com/roboticmindsecuador/?locale=es_LA"
               target="_blank" rel="noopener noreferrer" aria-label="Facebook" title="Facebook">
              <svg viewBox="0 0 512 512" aria-hidden="true"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"/></svg>
            </a>
            {/* Instagram */}
            <a role="listitem" className="social-btn"
               href="https://www.instagram.com/roboticminds.ec/?hl=es-la"
               target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Instagram">
              <svg viewBox="0 0 448 512" aria-hidden="true"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
            </a>
            {/* WhatsApp */}
            <a role="listitem" className="social-btn" href="https://api.whatsapp.com/send?phone=593981031263"
               target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" title="WhatsApp">
              <svg viewBox="0 0 448 512" aria-hidden="true"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157z"/></svg>
            </a>
            {/* TikTok */}
            <a role="listitem" className="social-btn"
               href="https://www.tiktok.com/@robotic_minds?_t=ZM-8xwfgpaJabu&_r=1"
               target="_blank" rel="noopener noreferrer" aria-label="TikTok" title="TikTok">
              <svg viewBox="0 0 448 512" aria-hidden="true"><path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0h88a121.18,121.18,0,0,0,1.86,22.17A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"/></svg>
            </a>
            {/* YouTube */}
            <a role="listitem" className="social-btn"
               href="https://www.youtube.com/@roboticminds9922"
               target="_blank" rel="noopener noreferrer" aria-label="YouTube" title="YouTube">
              <svg viewBox="0 0 576 512" aria-hidden="true"><path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305zM232.145 337.591V175.185l142.739 81.205-142.739 81.201z"/></svg>
            </a>
            {/* LinkedIn */}
            <a role="listitem" className="social-btn"
               href="https://www.linkedin.com/company/robotic-minds/?originalSubdomain=ec"
               target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" title="LinkedIn">
              <svg viewBox="0 0 448 512" aria-hidden="true"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg>
            </a>
          </div>
        </div>

        {/* 3) COPYRIGHT */}
        <div className="footer-bottom">
          <p>&copy; {currentYear} Robotic Minds. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
